// Generated by npm run generate-i18n-catalogs. Do not edit directly.

import { en } from "./en"
import { catalogAr } from "./ar"
import { catalogZhTW } from "./zh-TW"
import { catalogZhCN } from "./zh-CN"
import { catalogEs } from "./es"
import { catalogDe } from "./de"
import { catalogFr } from "./fr"
import { catalogIt } from "./it"
import { catalogPtBR } from "./pt-BR"
import { catalogJa } from "./ja"
import { catalogKo } from "./ko"
import { catalogNl } from "./nl"
import { catalogSv } from "./sv"
import { catalogRu } from "./ru"
import { catalogEnXPirate } from "./en-x-pirate"

export const languageDefinitions = [
  { id: "en", name: "English", flag: "🇺🇸", catalog: en },
  { id: "ar", name: "العربية", flag: "", catalog: catalogAr },
  { id: "zh-TW", name: "繁體中文", flag: "🇹🇼", catalog: catalogZhTW },
  { id: "zh-CN", name: "简体中文", flag: "🇨🇳", catalog: catalogZhCN },
  { id: "es", name: "Español", flag: "🇪🇸", catalog: catalogEs },
  { id: "de", name: "Deutsch", flag: "🇩🇪", catalog: catalogDe },
  { id: "fr", name: "Français", flag: "🇫🇷", catalog: catalogFr },
  { id: "it", name: "Italiano", flag: "🇮🇹", catalog: catalogIt },
  { id: "pt-BR", name: "Português (Brasil)", flag: "🇧🇷", catalog: catalogPtBR },
  { id: "ja", name: "日本語", flag: "🇯🇵", catalog: catalogJa },
  { id: "ko", name: "한국어", flag: "🇰🇷", catalog: catalogKo },
  { id: "nl", name: "Nederlands", flag: "🇳🇱", catalog: catalogNl },
  { id: "sv", name: "Svenska", flag: "🇸🇪", catalog: catalogSv },
  { id: "ru", name: "Русский", flag: "🇷🇺", catalog: catalogRu },
  { id: "en-x-pirate", name: "Pirate", flag: "🏴‍☠️", catalog: catalogEnXPirate },
] as const

export type RegisteredLanguage = (typeof languageDefinitions)[number]["id"]

export const legacySavedLanguageIds: Readonly<Record<string, RegisteredLanguage>> = {
  "pt": "pt-BR"
}

export const browserLanguageAliases: readonly { range: string, language: RegisteredLanguage }[] = [
  {
    "range": "zh-Hant",
    "language": "zh-TW"
  },
  {
    "range": "zh-TW",
    "language": "zh-TW"
  },
  {
    "range": "zh-HK",
    "language": "zh-TW"
  },
  {
    "range": "zh-MO",
    "language": "zh-TW"
  },
  {
    "range": "zh-Hans",
    "language": "zh-CN"
  },
  {
    "range": "zh-CN",
    "language": "zh-CN"
  },
  {
    "range": "zh-SG",
    "language": "zh-CN"
  },
  {
    "range": "zh",
    "language": "zh-TW"
  },
  {
    "range": "pt",
    "language": "pt-BR"
  }
]

export const languageFallbacks: Partial<Record<RegisteredLanguage, RegisteredLanguage>> = {}
